import ColumnChartIcon from 'src/shared/assets/icons/column-chart.svg';
import LineChartIcon from 'src/shared/assets/icons/line-chart.svg';
import StackedBarIcon from 'src/shared/assets/icons/stacked-bar.svg';

import { ChartType } from '../dashboard/types';

import styles from './dashboard-header.module.scss';

export const defaultChartTypeItems = [
  { key: ChartType.line, title: <LineChartIcon className={styles.switchIcon} /> },
  { key: ChartType.column, title: <ColumnChartIcon className={styles.switchIcon} /> },
];

export const chartTypeItems = [
  { key: ChartType.column, title: <ColumnChartIcon className={styles.switchIcon} /> },
  { key: ChartType.bar, title: <StackedBarIcon className={styles.switchIcon} /> },
];
